var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    id: "sentry",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F8FA",
    d: "M26,32H6c-3.314,0-6-2.686-6-6V6c0-3.314,2.686-6,6-6h20c3.314,0,6,2.686,6,6v20C32,29.314,29.314,32,26,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#26C6DA",
    d: "M23.776,20.831l-6.48-11.14C16.998,9.198,16.499,9,16,9c-0.499,0-0.997,0.296-1.295,0.691l-2.094,3.647l0.499,0.296c1.595,0.887,2.891,2.168,3.788,3.746c0.798,1.381,1.296,2.859,1.396,4.437h-1.495c-0.099-1.282-0.499-2.564-1.196-3.747c-0.698-1.38-1.795-2.464-3.19-3.254l-0.499-0.295L9.92,17.873l0.498,0.296c1.296,0.788,2.193,2.07,2.393,3.549H9.52c-0.099,0-0.2-0.099-0.2-0.099s-0.099-0.099,0-0.197l0.899-1.578C9.92,19.55,9.52,19.351,9.121,19.254l-0.897,1.578c-0.299,0.493-0.299,0.986,0,1.479C8.523,22.803,8.922,23,9.52,23h4.586v-0.591c0-1.085-0.299-2.071-0.797-3.057c-0.399-0.788-0.997-1.38-1.695-1.872l0.698-1.282c0.898,0.69,1.695,1.479,2.293,2.465c0.698,1.182,0.997,2.464,0.997,3.746v0.591h3.887v-0.591c0-1.971-0.498-3.944-1.595-5.718c-0.798-1.578-2.094-2.859-3.59-3.846l1.496-2.563c0.101-0.099,0.2-0.099,0.2-0.099c0.1,0,0.1,0,0.199,0.099l6.481,11.139c0.099,0.098,0,0.197,0,0.197s-0.1,0.099-0.2,0.099h-1.495v1.183h1.495c0.597,0.098,0.997-0.099,1.295-0.591C24.075,21.817,24.075,21.324,23.776,20.831z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentry);
export default __webpack_public_path__ + "static/media/sentry.6043324895413419e0e1579e362f07fc.svg";
export { ForwardRef as ReactComponent };